import { Component, OnInit } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { FirebaseAuthService } from '../../_services/firebase-auth.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { AlertService } from 'src/app/_services/alert.service';
import { map } from 'rxjs/operators';


/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

declare const gapi: any;
declare var FB: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  hide = true;
  completeRegister = false;
  dataUser: any;
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  facebookUser: any;
  matcher = new MyErrorStateMatcher();
  model: any = {};


  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<LoginComponent>, private router: Router,
              public firebaseAuthService: FirebaseAuthService, private alertService: AlertService) {

  }

  ngOnInit(): void {
  }

  async googleFirebaseLogin(): Promise<void>{
    try {
      const answ =  await this.firebaseAuthService.loginWithGoogle();
      if (answ.additionalUserInfo.isNewUser) {

        this.completeRegister = true;
        this.firebaseAuthService.publicUserToCreate = answ.user;
        this.dialogRef.disableClose = true;
      } else {

        this.firebaseAuthService.displayNameObs = this.firebaseAuthService.getPublicUserByEmail(answ.user.email).pipe(map(user => user ? user.displayName : null));

        this.firebaseAuthService.getLoguedPrivateProfileUser(answ.user.uid).subscribe(user =>{

          if (user) {
            this.alertService.openAlertDialog('logueado Correctamente', false, false);
            this.closeDialog();
          } else {
            this.completeRegister = true;
            this.firebaseAuthService.publicUserToCreate = answ.user;
            this.dialogRef.disableClose = true;
          }
        });
      }
    } catch (error) {
      console.log(error.code);

      if (error.code === 'auth/network-request-failed') {
        this.alertService.openAlertDialog('Parece que tenemos un problema, por favor revisa tu conexión a internet e ' +
        'inténtalo de nuevo. Si el problema persiste ponte en contacto con soporte.', true, false);

      } else {
        this.alertService.openAlertDialog('Ocurrió un error, inténtalo de nuevo y si el problema persiste' +
        'pongase en contacto con soporte', true, false);
      }

      this.closeDialog();
    }
  }

  async facebookFirebaseLogin(): Promise<void>{
    try {
      const answ = await this.firebaseAuthService.loginWithFacebook();
      if (answ.additionalUserInfo.isNewUser) {
        this.completeRegister = true;
        this.firebaseAuthService.publicUserToCreate = answ.user;
        this.dialogRef.disableClose = true;
      } else {

        this.firebaseAuthService.getLoguedPrivateProfileUser(answ.user.uid)
          .subscribe(user => {
            if (user) {
              this.alertService.openAlertDialog('logueado Correctamente', false, false);
              this.closeDialog();
            } else {
              this.completeRegister = true;
              this.firebaseAuthService.publicUserToCreate = answ.user;
              this.dialogRef.disableClose = true;
            }
          });
      }
    } catch (error) {
      console.log(error);
      if (error.code === 'auth/network-request-failed') {
        this.alertService.openAlertDialog('Parece que tenemos un problema, por favor revisa tu conexión a internet e ' +
        'inténtalo de nuevo. Si el problema persiste ponte en contacto con soporte.', true, false);

      } else {
        this.alertService.openAlertDialog('Ocurrió un error, inténtalo de nuevo y si el problema persiste' +
        'pongase en contacto con soporte', true, false);
      }

      this.closeDialog();
    }
  }



  async EmailAndPasswordlogin(): Promise<void>{
    // this.loading = true;
    this.firebaseAuthService.loginWithEmail(this.model.email , this.model.password)
      .then(result => {
        this.alertService.openAlertDialog('Logueado Correctamente', false, false);
        // this.loading = false;
        this.closeDialog();
      })
      .catch(error => {
        this.alertService.openAlertDialog('Datos incorrectos', false, false);
        // this.loading = false;
       });
  }

  login() {
    // this.authService.login(this.model).subscribe(next => {
    //   this.alertService.succes('Logueado Correctamente');
    //   this.loadLoguedUser(this.authService.decodedToken.email);
    //   this.closeDialog();
    // }, error => {
    //   console.log(error);
    //   if (error.error === 'Email not confirmed') {
    //     this.alertService.confirm('Por favor revisa tu correo para activar la cuenta'
    //     , () => this.answerAlert(), 'Cuando confirmes el correo estaremos listos!' );
    //     // this.alertService.error('Correo no confirmado');
    //     // this.alertService.error('Revisa tu correo y sigue las instrucicones');
    //   } else if (error.error === 'wrongMethod') {
    //     this.alertService.error('Inicia sesión con el método con el que te registraste');
    //   } else {
    //     this.alertService.error('Datos incorrectos');
    //   }
    // });
  }

  // loggedIn() {
  //   this.dataUser = JSON.parse(localStorage.getItem('loguedUser'));

  //   // return this.authService.loggedIn();
  // }



  showForgetPass() {

  }

  // answerAlert() {
  //   // this.alertService.succes('Cuando confirmes el correo estaremos listos!');
  //   this.router.navigate(['']);
  // }

  closeDialog() {
    this.dialogRef.close();
  }

  loadLoguedUser(email: string) {
    // this.userService.getUser(email).subscribe((user: User) => {
    //   console.log(user);
    //   this.user = user;
    //   localStorage.setItem('loguedUser', JSON.stringify(this.user));
    // }, error => {
    //   this.alertService.error(error);
    // });
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('loguedUser');
    this.closeDialog();
    this.router.navigate(['/home']);
    // this.alertService.message('Sesión cerrada');
  }

  async cancelSocialNetworkRegister(): Promise<void>{
    this.firebaseAuthService.publicUserToCreate.delete().then(() => {
      console.log('borrado');
      this.router.navigate(['']).then(() => { window.location.reload(); });
    }).catch(error => {
      console.log(error);
    });
    this.closeDialog();
  }


  async goToSocialNetworkRegister(): Promise<void>{
    this.dialogRef.disableClose = false;

    this.closeDialog();
    this.router.navigate([{outlets: {primary: 'social-network-register' ,sidebar: 'social-network-register'}}]).then(() => this.closeDialog());

  }


}
